import { AxiosError } from "axios";
import { ApptuitDatasource } from "../../datasources/apptuit/ApptuitDatasource";
import datasourceApiManager from "../DatasourceApiService";
import { InceptionResponse } from "../types";
import { CreateMicroSiteResponse, GenericAPIResult, PollCreateMicroSiteResponse } from "./types";

class MicrositeApiService {
  protected datasource: ApptuitDatasource;

  createCompanyMicrosite(request: {
    companyName?: string;
    prompt: string;
    isSlides?: boolean;
    enableDemo?: boolean;
    user_role?: string;
    business_unit?: string;
    group?: string;
    linkedInUrl?: string;
  }) {
    const requestBody: Record<string, any> = {
      ...(request.companyName && { company_name: request.companyName }),
      ...(request.linkedInUrl && { linkedinProfileUrl: request.linkedInUrl }),
      prompt: request.prompt,
      isSlides: request.isSlides || false,
      ...(request.user_role && { user_role: request.user_role }),
      ...(request.business_unit && { business_unit: request.business_unit }),
      ...(request.group && { group: request.group }),
      enableDemo: request.enableDemo || false
    };

    const fetchFn = () => this.datasource.post<CreateMicroSiteResponse, any>(this.getUrl("/create"), requestBody);

    return this.call(fetchFn);
  }

  getCreateCompanyMicrositeStatus(pollId: string) {
    const url = `/sales-portal/sales-portal/api/v1/microsite/status?pollId=${pollId}`;
    const fetchFn = () => this.datasource.get<PollCreateMicroSiteResponse>(url);

    return this.call(fetchFn);
  }

  protected getUrl(url = ""): string {
    if (url.startsWith("/")) {
      url = url.substring(1);
    }
    const initUrl = "/sales-portal/sales-portal/api/v1";
    return `${initUrl}/microsite/${url}`;
  }

  protected init() {
    this.datasource = datasourceApiManager.getDefault();
  }

  private isErrorResponse(statusCode: number) {
    return statusCode >= 400 && statusCode < 500;
  }

  private async call<R>(promiseFn: () => Promise<InceptionResponse<R>>) {
    this.init();

    const response: GenericAPIResult<R> = {
      data: null as R,
      error: false,
      message: ""
    };

    try {
      const { data, status, statusText } = await promiseFn();
      console.log("[MicrositeApiService] backend response", {
        timestamp: new Date().toISOString(),
        status,
        statusText,
        data
      });
      response.data = data;
      if (this.isErrorResponse(status)) {
        response.error = true;
        response.message = statusText;
      } else {
        response.data = data;
      }
    } catch (err: any) {
      const axiosErr = err as AxiosError<any>;
      console.error("[MicrositeApiService] backend error", {
        timestamp: new Date().toISOString(),
        message: axiosErr.message,
        status: axiosErr.response?.status,
        statusText: axiosErr.response?.statusText,
        data: axiosErr.response?.data
      });
      response.error = true;
      response.message = (err as Error).message;
    }

    return response;
  }
}

export const micrositeApiService = new MicrositeApiService();
